import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton, SpecraOverlayDialog } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { X } from 'lucide-react';
import { useState } from 'react';
/**
 * GRW-30 (AUDIT P3): a destructive pursuit action always asks first. The
 * trigger keeps the caller's testid; the dialog's confirm button carries
 * `capture.removeConfirm`.
 */ export function ConfirmRemoveButton({ title, description, confirmLabel = 'Remove', onConfirm, disabled, trigger, testId }) {
    const [open, setOpen] = useState(false);
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        open: open,
        onOpenChange: setOpen,
        title: title,
        description: description,
        size: "sm",
        testId: Testids.capture.removeConfirmDialog,
        trigger: trigger ?? /*#__PURE__*/ _jsx(SpecraButton, {
            variant: "ghost",
            size: "sm",
            "data-testid": testId,
            disabled: disabled,
            iconLeft: /*#__PURE__*/ _jsx(X, {
                className: "h-3.5 w-3.5"
            }),
            children: "Remove"
        }),
        footerProps: {
            confirmLabel,
            onConfirm: ()=>{
                setOpen(false);
                onConfirm();
            },
            confirmProps: {
                'data-testid': Testids.capture.removeConfirm
            }
        },
        children: /*#__PURE__*/ _jsx("span", {})
    });
}
